import { ChartLineUp } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { AppLink } from "./Header";
import { getAnalyticsConsent, initializeAnalytics, setAnalyticsConsent, type AnalyticsConsent as Choice } from "../lib/analytics";

export function AnalyticsConsent() {
  const [choice, setChoice] = useState<Choice | null>(() => getAnalyticsConsent());

  useEffect(() => {
    if (choice === "granted") initializeAnalytics();
    const update = (event: Event) => setChoice((event as CustomEvent<Choice>).detail);
    window.addEventListener("kleanbg:analytics-consent", update);
    return () => window.removeEventListener("kleanbg:analytics-consent", update);
  }, [choice]);

  if (choice) return null;
  return <aside className="consent-banner" aria-labelledby="consent-title">
    <ChartLineUp size={24} weight="fill" />
    <div><h2 id="consent-title">Help us improve KleanBG?</h2><p>Optional Google Analytics tells us which features work. We never send images, filenames, email addresses, or X handles. <AppLink to="/privacy">Privacy details</AppLink></p></div>
    <div className="consent-actions"><button className="secondary-button" onClick={() => setAnalyticsConsent("denied")}>Only necessary</button><button className="primary-button" onClick={() => setAnalyticsConsent("granted")}>Allow analytics</button></div>
  </aside>;
}

export function AnalyticsChoices() {
  const [choice, setChoice] = useState<Choice | null>(() => getAnalyticsConsent());
  function choose(next: Choice) { setAnalyticsConsent(next); setChoice(next); }
  return <div className="analytics-choices" role="group" aria-label="Analytics preference">
    <button className={choice === "denied" ? "secondary-button selected" : "secondary-button"} onClick={() => choose("denied")}>Only necessary</button>
    <button className={choice === "granted" ? "secondary-button selected" : "secondary-button"} onClick={() => choose("granted")}>Allow analytics</button>
    <span role="status">{choice ? `Current choice: ${choice === "granted" ? "analytics allowed" : "necessary only"}.` : "No choice saved yet."}</span>
  </div>;
}
